import PropTypes from 'prop-types';
import React from 'react';
import { noop } from '../../../../utils/noop';
import { ImageGalleryControlButtonsStyles } from './ImageGalleryControlButtons.style';

const ImageGalleryControlButtons = ({ onPreviousHeadLine, onNextHeadline, onMoveOver, variant, isConnect }) => {
  const connectClass = isConnect ? 'connect-button' : '';
  return (
    <>
      <button
        id="PDP_swipe_photo_left"
        type="button"
        className={`headline-control left ${variant} ${connectClass}`}
        onClick={onPreviousHeadLine}
        onMouseMove={onMoveOver}
      >
        <i className="icon csicon-arrow_left" />
      </button>

      <button
        id="PDP_swipe_photo_right"
        type="button"
        className={`headline-control right ${variant} ${connectClass}`}
        onClick={onNextHeadline}
        onMouseMove={onMoveOver}
      >
        <i className="icon i-gallery csicon-arrow_right" />
      </button>
      <style jsx>{ImageGalleryControlButtonsStyles}</style>
    </>
  );
};

ImageGalleryControlButtons.defaultProps = {
  onMoveOver: noop,
  variant: 'transparent',
  isConnect: false,
};

ImageGalleryControlButtons.propTypes = {
  onPreviousHeadLine: PropTypes.func.isRequired,
  onNextHeadline: PropTypes.func.isRequired,
  onMoveOver: PropTypes.func,
  variant: PropTypes.oneOf(['opaque', 'transparent', 'smallAndTransparent']),
  isConnect: PropTypes.bool,
};

export default ImageGalleryControlButtons;
